import { memo } from "react";
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import { StepLabel, type StepLabelProps } from "ui/organizms/ECommerce/Onboarding/common";

const BusinessInformationLabel = (props: Partial<StepLabelProps>) => (
    <StepLabel
        to={`${ECommerceOnboardingStep[ECommerceOnboarding.HighRiskMerchant].BusinessInformation}`}
        Icon={ShoppingBagOutlinedIcon}
        {...props}
    >
        Business Information
    </StepLabel>
);

export default memo(BusinessInformationLabel);
